import { SvgIconVariables } from '../../../teams/components/SvgIcon/svgIconVariables';

export default (siteVars): Partial<SvgIconVariables> => ({
  disabledColor: siteVars.colors.grey[450],
});
